import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Message, Table } from "semantic-ui-react";

interface IEmptyTableRow extends WithTranslation {
  header?: string;
  content?: string;
  colSpan?: number;
}

class EmptyTableRow extends React.Component<IEmptyTableRow> {
  public render() {
    const { t, header, content, colSpan } = this.props;
    return (
      <Table.Row>
        <Table.Cell textAlign="center" colSpan={colSpan || 10}>
          <Message
            icon="inbox"
            header={header || t("EmptyTableRow.noResult")}
            content={content || t("EmptyTableRow.PleaseTryAgain")}
          />
        </Table.Cell>
      </Table.Row>
    );
  }
}
export default withTranslation()(EmptyTableRow);
